import React, {useState, useEffect} from "react";
import {ListByPrime, ListByCourseType, DeleteCourse} from "../services/CoursesServices";

export const PrimeContext = React.createContext({});

export default function PrimeProvider({children}) {
   const [primeData, setPrimeData] = useState([]); // lista certificado prime
   const [masterclassData, setMasterclassData] = useState([]); // lista masterclass
   const [isLoading, setIsLoading] = useState({prime: true, masterclass: true});
   const [isSaving, setSaving] = useState(false);

   const getPrimeData = (force = false) => {
      if (primeData.length > 1 && !force) return null;
      ListByPrime()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setPrimeData(data);
            setIsLoading({...isLoading, prime: false});
         });
   };

   const getMasterclass = () => {
      ListByCourseType(5)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setMasterclassData(data);
            setIsLoading({...isLoading, masterclass: false});
         });
   };

   const deleteCoursePrime = (id, type) => {
      setSaving(true);
      DeleteCourse(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            // const newList = essentialList.filter((course) => course.idCourse !== id);
            if (type === 2) {
               filterPrime(id);
            } else {
               filterMaster(id);
            }
         })
         .then(() => {
            setSaving(false);
         })
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   let filterPrime = (id) => {
      let newPrime = primeData.filter((item) => item.idCourse !== id);
      setPrimeData(newPrime);
   };
   let filterMaster = (id) => {
      let newPrime = masterclassData.filter((item) => item.idCourse !== id);
      setMasterclassData(newPrime);
   };

   return (
      <PrimeContext.Provider
         value={{
            getMasterclass,
            masterclassData,
            setMasterclassData,
            primeData,
            setPrimeData,
            getPrimeData,
            isLoading,
            isSaving,
            deleteCoursePrime,
         }}
      >
         {children}
      </PrimeContext.Provider>
   );
}

const datExample = [
   {
      id: 1,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 2,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: true,
      hours: "3 horas",
   },
   {
      id: 4,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 6,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 8,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: false,
      hours: "3 horas",
   },
];
